import store from '../store'
import guid from '../utils/guid'

function findWaypointWithinTimeInterval(time, tolerance) {
  const selection = store.state.selection
  const wpInRange = (selection.scene && selection.scene.waypoints) ? selection.scene.waypoints.find(wp => {
          console.log('wp, time', wp, time, tolerance)
          return (wp.time >= time - tolerance && wp.time <= time + tolerance)
        }) : null
  return wpInRange
}

function findPreviousWaypoint(wp) {
  const selection = store.state.selection
  const wps = sortWaypoints(selection.scene.waypoints || [])
  return wps[Math.max(0, wps.indexOf(wp) - 1)]
}

function findNextWaypoint(wp) {
  const selection = store.state.selection
  const wps = sortWaypoints(selection.scene.waypoints || [])
  return wps[Math.min(wps.length - 1, wps.indexOf(wp) + 1)]
}

function createTrackingObjectFromWaypoint(wp, time, timeTo, type = 'Continuous', skip = 5) {
  console.log('store.state.video', store.state.video)
  const rw = wp.w / store.state.video.dimensions.width
  const rh = wp.h / store.state.video.dimensions.height
  const trackingObject = {
        src: store.state.video.src,
        ref: wp.id,
        type: type,
        start: time,
        end: timeTo,
        bbox: {
            x: wp.x - rw / 2, // 0.5835,
            y: wp.y - rh / 2, // 0.1042,
            w: rw,
            h: rh
        },
        skip: 5
    }
    return trackingObject
}

function createWaypointFromTrackpoint(tp) {
  const vw = store.state.video.dimensions.width
  const vh = store.state.video.dimensions.height
  const wp = {
    id: guid(),
    time: tp.time,
    x: tp.center.X,
    y: tp.center.Y,
    w: tp.width * vw,
    h: tp.height * vh,
    type: 'tracked'
  }
  return wp
}

function sortWaypoints(waypoints) {
  if (!waypoints) {
    return waypoints
  }
  return waypoints.sort((wp1, wp2) => {
      if (wp1.time === wp2.time) {
        return 0
      } else {
        return wp1.time < wp2.time ? -1 : 1
      }
  })
}

export default {
  findWaypointWithinTimeInterval,
  createTrackingObjectFromWaypoint,
  createWaypointFromTrackpoint,
  sortWaypoints,
  findNextWaypoint,
  findPreviousWaypoint
}
